import { TableColumn } from '../types/column'
import { TableData } from '../types/data'
import { getColumnsIds } from './getColumnsIds'

export const getHiddenColumnsIds = <T extends TableData>(columns: TableColumn<T>[]): string[] =>
  getColumnsIds(columns.filter(({ hidden }) => !!hidden))
